import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { superchargerGameFieldsFragment } from '#src/lib/game-utils/fragments/supercharger-game-fields-fragment';
import { selectTimeZone } from '#src/store/intl/selectors';
import { isAuthenticated } from '#src/store/session/selectors';

export const query = gql`
  query SuperchargerGameDetail(
    $gameId: Int!
    $timeZone: String!
    $isAuthenticated: Boolean!
  ) {
    game(id: $gameId, type: falkor) {
      id
      ...SuperchargerGameFieldsFragment
    }
  }

  ${superchargerGameFieldsFragment}
`;

// Same field selection as invite-landing.js's Invite query, but keyed on
// gameId directly instead of an invite token - used by GameDetailScreenV2
// to render the same supercharger UI on /games/:gameId.
export function useSuperchargerGameQuery({ gameId, skip }) {
  const timeZone = useSelector(selectTimeZone);
  const loggedIn = useSelector(isAuthenticated);
  const { data, loading, error } = useQuery(query, {
    skip: skip || !gameId,
    variables: { gameId, timeZone, isAuthenticated: loggedIn },
  });

  return {
    game: data?.game || null,
    loading,
    error,
  };
}
